import style from './style.module.css';

type CircleProps = {
  percent: number;
  size: string;
  color: string;
  borderWidth: string;
  shouldEase: boolean;
};

const ProgressCircle = ({
  percent,
  size,
  color,
  borderWidth,
  shouldEase,
}: CircleProps) => {
  return (
    <span
      class={style.progressCircle}
      style={{
        width: size,
        height: size,
        '--border-width': borderWidth,
      }}
    >
      <span
        class={style.progressCircleInner}
        style={{
          transform: `rotate(${45 + percent * 360}deg)`,
          transition: shouldEase ? 'transform 0.15s ease' : 'none',
          borderColor: percent > 0.5 ? 'transparent' : '#eee',
          borderLeftColor: percent > 0.5 ? color : 'transparent',
          borderBottomColor: percent > 0.5 ? color : 'transparent',
        }}
      ></span>
    </span>
  );
};

export default ProgressCircle;
